import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { PaymentSources } from '../../../enums/enums'
import { convertITrackToPlayerTrack, ICartTrack } from '../../../Interface/track'
import { PlayerLogic } from '../../../player/AngPlayer'
import { CartService, ICartGroup } from '../../../services/cart.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { AppType } from '../../../types/app.type'

@Component({
  selector: 'bmcore-cart-page',
  templateUrl: './bmcore-cart-page.component.html',
  styleUrls: ['./bmcore-cart-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreCartPageComponent implements OnInit {
  @Input() paymentSource: PaymentSources
  @Input() colorSettingsMode = false
  @Input() appType: AppType
  @Input() widgetId: number

  lg: LgType
  cartGroups: ICartGroup[] = []
  trackCount: number

  constructor(
    private cartService: CartService,
    private i18nService: I18nService,
    private player: PlayerLogic
  ) {}

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.cartGroups = this.cartService.groups.getGroups()
    this.cartService.addSubscriber('group-updated', () => this.changedCart())
    this.cartService.addSubscriber('group-updated', () => this.getTracksCount())
    this.getTracksCount()
  }

  changedCart() {
    this.cartGroups = this.cartService.groups.getGroups()
  }

  getTracksCount() {
    this.trackCount = this.cartService.getBeats().length
  }

  setPlaylist(tracks: ICartTrack[]) {
    this.player.setPlayList(tracks.map(convertITrackToPlayerTrack))
  }

  sortTracksByIsOk(beats: ICartTrack[]): ICartTrack[] {
    return beats.sort((a, b) => (!a.isOK ? 1 : -1))
  }
}
